import { find, propEq } from 'ramda'

const getModelMinLeasingRate = (models, model) => {
  const { minLeasingRate } = find(propEq('model', model))(models)
  return minLeasingRate
}

export default getModelMinLeasingRate
